(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["royded-judgeme-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Defaults drive Judge.me's select; bundles pass their own select, its box, the row to sit in, and no allow list.
    function createReviewSort(root, { select = '.jm-sort-filter__select', box = '.jm-sort-filter', host = null, allowed = null } = {}) {
      const shell = root.querySelector('.rd-reviews__shell');
      if (!shell) return { refresh() {}, disconnect() {} };
      const parent = host || shell;
      const lifetime = new AbortController();
      const wrapper = document.createElement('div');
      const trigger = document.createElement('button');
      const label = document.createElement('span');
      const list = document.createElement('ul');
      const id = `rd-review-sort-${crypto.randomUUID()}`;
      wrapper.className = 'rd-review-sort';
      wrapper.hidden = true;
      trigger.className = 'rd-review-sort__trigger';
      trigger.type = 'button';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', id);
      list.className = 'rd-review-sort__list';
      list.id = id;
      list.hidden = true;
      list.tabIndex = -1;
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', 'Sort reviews');
      trigger.append(label);
      wrapper.append(trigger, list);
      const widget = shell.querySelector('#judgeme_product_reviews');
      parent.insertBefore(wrapper, !host && widget?.parentElement === shell ? widget : null);
      let native = null;
      let original = null;
      let nativeEvents = null;
      let signature = '';
      let options = [];
      let active = -1;
      let frame = 0;
      let disposed = false;
      const setAttribute = (node, name, value) => {
        if (node.getAttribute(name) !== value) node.setAttribute(name, value);
      };
      const setStyle = (name, value) => {
        if (wrapper.style.getPropertyValue(name) !== value) wrapper.style.setProperty(name, value);
      };
      function close(returnFocus = false) {
        if (list.hidden) return;
        list.hidden = true;
        setAttribute(trigger, 'aria-expanded', 'false');
        if (returnFocus && !trigger.disabled) trigger.focus({ preventScroll: true });
      }
      function position() {
        frame = 0;
        if (!native || !native.isConnected || !root.isConnected) return;
        const rect = native.closest(box)?.getBoundingClientRect() || native.getBoundingClientRect();
        const origin = parent.getBoundingClientRect();
        const visible = rect.width > 0 && rect.height > 0;
        wrapper.hidden = !visible;
        if (!visible) { close(); return; }
        setStyle('left', `${rect.left - origin.left - parent.clientLeft + parent.scrollLeft}px`);
        setStyle('top', `${rect.top - origin.top - parent.clientTop + parent.scrollTop}px`);
        setStyle('width', `${rect.width}px`);
        if (!list.hidden) {
          const above = rect.top - 12;
          const below = window.innerHeight - rect.bottom - 12;
          const upward = below < 160 && above > below;
          setAttribute(wrapper, 'data-side', upward ? 'top' : 'bottom');
          setAttribute(wrapper, 'data-align', rect.left + Math.max(rect.width, 240) > window.innerWidth - 12 ? 'right' : 'left');
          setStyle('--rd-sort-max-height', `${Math.max(44, Math.min(308, upward ? above : below))}px`);
        }
      }
      const schedule = () => { if (!disposed && !frame) frame = requestAnimationFrame(position); };
      function activate(index) {
        active = index;
        [...list.children].forEach((option, i) => {
          const selected = i === active;
          if (option.classList.contains('is-active') !== selected) option.classList.toggle('is-active', selected);
        });
        const option = list.children[active];
        if (option) {
          setAttribute(list, 'aria-activedescendant', option.id);
          if (option.offsetTop < list.scrollTop) list.scrollTop = option.offsetTop;
          else if (option.offsetTop + option.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = option.offsetTop + option.offsetHeight - list.clientHeight;
        } else list.removeAttribute('aria-activedescendant');
      }
      const enabled = () => options.map((option, index) => !option.disabled && !option.hidden ? index : -1).filter(index => index >= 0);
      function open(last = false) {
        refresh();
        if (!native || trigger.disabled || wrapper.hidden) return;
        const indices = enabled();
        if (!indices.length) return;
        list.hidden = false;
        setAttribute(trigger, 'aria-expanded', 'true');
        position();
        const selected = native.selectedIndex;
        activate(indices.includes(selected) ? selected : indices[last ? indices.length - 1 : 0]);
        list.focus({ preventScroll: true });
      }
      function choose(index) {
        if (!native || native.disabled || !options[index] || options[index].disabled || options[index].hidden) return;
        native.selectedIndex = index;
        close(true);
        native.dispatchEvent(new Event('change', { bubbles: true }));
        refresh();
      }
      function releaseNative() {
        nativeEvents?.abort();
        observer.disconnect();
        if (native && original) {
          for (const [attribute, value] of Object.entries(original)) {
            if (value === null) native.removeAttribute(attribute);
            else native.setAttribute(attribute, value);
          }
        }
        native = null;
        original = null;
        signature = '';
      }
      function refresh() {
        if (disposed) return;
        const next = root.querySelector(select);
        if (next !== native) {
          const wasFocused = wrapper.contains(document.activeElement);
          close();
          releaseNative();
          native = next;
          if (native) {
            original = Object.fromEntries(['tabindex', 'aria-hidden', 'data-rd-sort-ready'].map(attribute => [attribute, native.getAttribute(attribute)]));
            nativeEvents = new AbortController();
            native.addEventListener('change', refresh, { signal: nativeEvents.signal });
            native.addEventListener('input', refresh, { signal: nativeEvents.signal });
            observer.observe(native, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'selected', 'value', 'label', 'hidden'] });
          }
          if (wasFocused && native) queueMicrotask(() => { if (!disposed && !trigger.disabled) trigger.focus({ preventScroll: true }); });
        }
        if (!native || !native.options.length) { close(); wrapper.hidden = true; return; }
        const current = [...native.options].map(option => ({ value: option.value, label: option.label, disabled: option.disabled || (option.parentElement?.tagName === 'OPTGROUP' && option.parentElement.disabled), hidden: option.hidden || (allowed !== null && !allowed.includes(option.value)) }));
        const associatedLabel = [...(native.labels || [])].map(node => node.textContent.trim()).filter(Boolean).join(' ');
        const referencedLabel = (native.getAttribute('aria-labelledby') || '').split(/\s+/).map(labelId => document.getElementById(labelId)?.textContent.trim()).filter(Boolean).join(' ');
        const accessibleName = (referencedLabel || native.getAttribute('aria-label') || associatedLabel || 'Sort reviews by').replace(/[:\s]+$/, '');
        const nextSignature = JSON.stringify([current, native.selectedIndex, native.disabled, accessibleName]);
        if (nextSignature !== signature) {
          const wasOpen = !list.hidden;
          signature = nextSignature;
          options = current;
          list.replaceChildren(...options.map((option, index) => {
            const item = document.createElement('li');
            item.className = 'rd-review-sort__option';
            item.id = `${id}-${index}`;
            item.dataset.index = String(index);
            item.textContent = option.label;
            item.hidden = option.hidden;
            item.setAttribute('role', 'option');
            item.setAttribute('aria-selected', String(index === native.selectedIndex));
            if (option.disabled) item.setAttribute('aria-disabled', 'true');
            return item;
          }));
          const selectedText = options[native.selectedIndex]?.label || '';
          if (label.textContent !== selectedText) label.textContent = selectedText;
          setAttribute(trigger, 'aria-label', `${accessibleName}: ${selectedText}`);
          setAttribute(list, 'aria-label', accessibleName);
          if (trigger.disabled !== (native.disabled || root.dataset.reviewAutoloading === 'true' || enabled().length === 0)) trigger.disabled = native.disabled || root.dataset.reviewAutoloading === 'true' || enabled().length === 0;
          if (trigger.disabled) close();
          else if (wasOpen) activate(enabled().includes(active) ? active : enabled()[0]);
        }
        if (trigger.disabled !== (native.disabled || root.dataset.reviewAutoloading === 'true' || enabled().length === 0)) trigger.disabled = native.disabled || root.dataset.reviewAutoloading === 'true' || enabled().length === 0;
        if (trigger.disabled) close();
        setAttribute(native, 'tabindex', '-1');
        setAttribute(native, 'aria-hidden', 'true');
        setAttribute(native, 'data-rd-sort-ready', 'true');
        position();
      }
      const observer = new MutationObserver(refresh);
      const resize = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
      resize?.observe(shell);
      if (host) resize?.observe(host);
      trigger.addEventListener('click', () => list.hidden ? open() : close(true), { signal: lifetime.signal });
      trigger.addEventListener('keydown', event => {
        if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          open(event.key === 'ArrowUp' || event.key === 'End');
          if (event.key === 'Home') activate(enabled()[0]);
          if (event.key === 'End') activate(enabled().at(-1));
        }
      }, { signal: lifetime.signal });
      list.addEventListener('click', event => {
        const option = event.target.closest('.rd-review-sort__option');
        if (option && list.contains(option)) choose(Number(option.dataset.index));
      }, { signal: lifetime.signal });
      list.addEventListener('keydown', event => {
        const indices = enabled();
        if (event.key === 'Tab') { close(true); return; }
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(true); return; }
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); choose(active); return; }
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key) || !indices.length) return;
        event.preventDefault();
        const index = indices.indexOf(active);
        activate(event.key === 'Home' ? indices[0] : event.key === 'End' ? indices.at(-1) : indices[(index + (event.key === 'ArrowDown' ? 1 : -1) + indices.length) % indices.length]);
      }, { signal: lifetime.signal });
      document.addEventListener('pointerdown', event => { if (!wrapper.contains(event.target)) close(); }, { signal: lifetime.signal });
      document.addEventListener('focusin', event => { if (!wrapper.contains(event.target)) close(); }, { signal: lifetime.signal });
      window.addEventListener('resize', schedule, { signal: lifetime.signal });
      window.addEventListener('scroll', schedule, { signal: lifetime.signal, capture: true, passive: true });
      refresh();
      return { refresh, disconnect() {
        if (disposed) return;
        disposed = true;
        lifetime.abort();
        resize?.disconnect();
        cancelAnimationFrame(frame);
        releaseNative();
        wrapper.remove();
      } };
    }
    const funnel = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M2 3h12l-4.6 5.4v4.8l-2.8 1.3V8.4z" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>';
    const ratingOf = card => {
      const match = (card.querySelector('.jm-star-rating, .rd-rv__stars')?.getAttribute('aria-label') || '').match(/\d+(?:[.,]\d+)?/);
      return match ? Math.round(Number(match[0].replace(',', '.'))) : 0;
    };
    // Rating, photo and (bundles) product filters in a panel under a square button laid over the anchor, like the sort list.
    function createReviewFilter(root, { anchor: anchorSelector, host = null, products = [], onChange }) {
      const shell = root.querySelector('.rd-reviews__shell');
      if (!shell) return { refresh() {}, disconnect() {}, matches: () => true, active: () => false };
      const parent = host || shell;
      const lifetime = new AbortController();
      const wrapper = document.createElement('div');
      const trigger = document.createElement('button');
      const count = document.createElement('span');
      const panel = document.createElement('div');
      const id = `rd-review-filter-${crypto.randomUUID()}`;
      const state = { rating: new Set(), photos: false, product: new Set() };
      wrapper.className = 'rd-review-filter';
      wrapper.hidden = true;
      trigger.className = 'rd-review-filter__trigger';
      trigger.type = 'button';
      trigger.innerHTML = funnel;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', id);
      trigger.setAttribute('aria-label', 'Filter reviews');
      count.className = 'rd-review-filter__count';
      count.setAttribute('aria-hidden', 'true');
      trigger.append(count);
      panel.className = 'rd-review-filter__panel';
      panel.id = id;
      panel.hidden = true;
      panel.setAttribute('role', 'group');
      panel.setAttribute('aria-label', 'Filter reviews');
      wrapper.append(trigger, panel);
      const widget = shell.querySelector('#judgeme_product_reviews');
      parent.insertBefore(wrapper, !host && widget?.parentElement === shell ? widget : null);
      let anchor = null;
      let original = null;
      let clear = null;
      let frame = 0;
      const setAttribute = (node, name, value) => {
        if (node.getAttribute(name) !== value) node.setAttribute(name, value);
      };
      const setStyle = (name, value) => {
        if (wrapper.style.getPropertyValue(name) !== value) wrapper.style.setProperty(name, value);
      };
      const total = () => state.rating.size + state.product.size + (state.photos ? 1 : 0);
      function sync() {
        const active = total();
        panel.querySelectorAll('input').forEach(input => {
          const checked = input.name === 'photos' ? state.photos : state[input.name].has(input.name === 'rating' ? Number(input.value) : input.value);
          if (input.checked !== checked) input.checked = checked;
        });
        if (clear && clear.disabled !== !active) clear.disabled = !active;
        if (count.textContent !== (active ? String(active) : '')) count.textContent = active ? String(active) : '';
        if (trigger.classList.contains('is-active') !== active > 0) trigger.classList.toggle('is-active', active > 0);
        setAttribute(trigger, 'aria-label', active ? `Filter reviews, ${active} active` : 'Filter reviews');
      }
      // Built on first open so Judge.me's own wording (jdgmSettings) has loaded.
      function build() {
        const settings = window.jdgmSettings || {};
        const group = (name, legend, items, wide = false) => {
          const fieldset = document.createElement('fieldset');
          const title = document.createElement('legend');
          const options = document.createElement('div');
          fieldset.className = 'rd-review-filter__group';
          title.className = 'rd-review-filter__legend';
          title.textContent = legend;
          options.className = 'rd-review-filter__options';
          options.append(...items.map(([value, text, label]) => {
            const option = document.createElement('label');
            const input = document.createElement('input');
            option.className = `rd-review-filter__option${wide ? ' rd-review-filter__option--wide' : ''}`;
            input.type = 'checkbox';
            input.name = name;
            input.value = value;
            if (label) input.setAttribute('aria-label', label);
            option.append(input, text);
            return option;
          }));
          fieldset.append(title, options);
          return fieldset;
        };
        clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'rd-review-filter__clear';
        clear.textContent = settings.review_widget_clear_filters_text || 'Clear filters';
        panel.append(
          group('rating', settings.review_widget_filter_rating_title || 'Rating', [5, 4, 3, 2, 1].map(stars => [String(stars), `${stars} ★`, `${stars} ${stars === 1 ? 'star' : 'stars'}`])),
          group('photos', 'Photos', [['true', root.dataset.photosLabel || 'With photos only']], true),
          ...(products.length > 1 ? [group('product', 'Product', products.map(name => [name, name]), true)] : []),
          clear
        );
        sync();
      }
      function close(returnFocus = false) {
        if (panel.hidden) return;
        panel.hidden = true;
        wrapper.classList.remove('is-open');
        setAttribute(trigger, 'aria-expanded', 'false');
        if (returnFocus) trigger.focus({ preventScroll: true });
      }
      function position() {
        frame = 0;
        if (!anchor || !anchor.isConnected || !root.isConnected) return;
        const rect = anchor.getBoundingClientRect();
        const origin = parent.getBoundingClientRect();
        const visible = rect.width > 0 && rect.height > 0;
        if (wrapper.hidden === visible) wrapper.hidden = !visible;
        if (!visible) { close(); return; }
        setStyle('left', `${rect.left - origin.left - parent.clientLeft + parent.scrollLeft}px`);
        setStyle('top', `${rect.top - origin.top - parent.clientTop + parent.scrollTop}px`);
        setStyle('width', `${rect.width}px`);
        setStyle('height', `${rect.height}px`);
        if (!panel.hidden) {
          const above = rect.top - 12;
          const below = window.innerHeight - rect.bottom - 12;
          const upward = below < 260 && above > below;
          setAttribute(wrapper, 'data-side', upward ? 'top' : 'bottom');
          setAttribute(wrapper, 'data-align', rect.left + Math.min(280, window.innerWidth - 32) > window.innerWidth - 12 ? 'right' : 'left');
          setStyle('--rd-filter-max-height', `${Math.max(120, Math.min(480, upward ? above : below))}px`);
        }
      }
      const schedule = () => { if (!frame) frame = requestAnimationFrame(position); };
      function open() {
        if (wrapper.hidden) return;
        if (!clear) build();
        panel.hidden = false;
        wrapper.classList.add('is-open');
        setAttribute(trigger, 'aria-expanded', 'true');
        position();
        panel.querySelector('input')?.focus({ preventScroll: true });
      }
      function restore() {
        if (!anchor || !original) return;
        for (const [attribute, value] of Object.entries(original)) {
          if (value === null) anchor.removeAttribute(attribute);
          else anchor.setAttribute(attribute, value);
        }
      }
      function refresh() {
        const next = root.querySelector(anchorSelector);
        if (next !== anchor) {
          close();
          restore();
          anchor = next;
          original = anchor ? Object.fromEntries(['tabindex', 'aria-hidden', 'data-rd-filter-ready'].map(attribute => [attribute, anchor.getAttribute(attribute)])) : null;
        }
        if (!anchor) { wrapper.hidden = true; return; }
        setAttribute(anchor, 'tabindex', '-1');
        setAttribute(anchor, 'aria-hidden', 'true');
        setAttribute(anchor, 'data-rd-filter-ready', 'true');
        schedule();
      }
      const resize = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
      resize?.observe(shell);
      if (host) resize?.observe(host);
      trigger.addEventListener('click', () => panel.hidden ? open() : close(true), { signal: lifetime.signal });
      wrapper.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || panel.hidden) return;
        event.preventDefault();
        event.stopPropagation();
        close(true);
      }, { signal: lifetime.signal });
      panel.addEventListener('change', event => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (input.name === 'photos') state.photos = input.checked;
        else {
          const value = input.name === 'rating' ? Number(input.value) : input.value;
          if (input.checked) state[input.name].add(value);
          else state[input.name].delete(value);
        }
        sync();
        onChange();
      }, { signal: lifetime.signal });
      panel.addEventListener('click', event => {
        if (!event.target.closest('.rd-review-filter__clear')) return;
        state.rating.clear();
        state.product.clear();
        state.photos = false;
        sync();
        onChange();
        // Clear disables itself, so keep focus inside the panel.
        panel.querySelector('input')?.focus({ preventScroll: true });
      }, { signal: lifetime.signal });
      document.addEventListener('pointerdown', event => { if (!wrapper.contains(event.target)) close(); }, { signal: lifetime.signal });
      document.addEventListener('focusin', event => { if (!wrapper.contains(event.target)) close(); }, { signal: lifetime.signal });
      window.addEventListener('resize', schedule, { signal: lifetime.signal });
      window.addEventListener('scroll', schedule, { signal: lifetime.signal, capture: true, passive: true });
      refresh();
      return {
        refresh,
        matches: entry => (!state.rating.size || state.rating.has(entry.rating)) && (!state.photos || entry.photos) && (!state.product.size || state.product.has(entry.product)),
        active: () => total() > 0,
        disconnect() {
          lifetime.abort();
          resize?.disconnect();
          cancelAnimationFrame(frame);
          restore();
          wrapper.remove();
        }
      };
    }
    // Bundles list server-rendered cards (rd-bundle-reviews), so filter and sort reorder those cards in place.
    function createBundleTools(root) {
      const grid = root.querySelector('.rd-rv__grid');
      const tools = root.querySelector('.rd-review-tools');
      const select = tools?.querySelector('.rd-review-tools__select');
      if (!grid || !select) return null;
      const step = Number(root.querySelector('[data-rd-rv]')?.dataset.initial) || 10;
      const more = root.querySelector('.rd-rv__more');
      const empty = root.querySelector('.rd-reviews__empty');
      const lifetime = new AbortController();
      const entries = [...grid.querySelectorAll('.rd-rv__card')].map((card, index) => ({
        card,
        index,
        rating: ratingOf(card),
        photos: card.classList.contains('rd-rv__card--media'),
        date: Date.parse(card.querySelector('.rd-rv__date')?.getAttribute('datetime') || '') || 0,
        product: card.querySelector('.rd-rv__product-name')?.textContent.trim() || ''
      }));
      // Pictures first and Most recent match the server order in rd-bundle-reviews.
      const orders = {
        created_at: (a, b) => b.date - a.date,
        highest_rating: (a, b) => b.rating - a.rating || b.date - a.date,
        lowest_rating: (a, b) => a.rating - b.rating || b.date - a.date,
        pictures_first: (a, b) => b.photos - a.photos || b.date - a.date
      };
      let frame = 0;
      const apply = () => {
        const order = orders[select.value] || orders.created_at;
        const shown = entries.filter(entry => filter.matches(entry)).sort((a, b) => order(a, b) || a.index - b.index);
        grid.replaceChildren(...shown.map(entry => entry.card));
        shown.forEach((entry, index) => { entry.card.hidden = index >= step; });
        if (more) more.hidden = shown.length <= step;
        const text = shown.length ? '' : root.dataset.filterEmpty;
        if (empty && empty.textContent !== text) empty.textContent = text;
        // Same measuring as rd-bundle-reviews, for cards that were hidden when it last ran.
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const visible = shown.map(entry => entry.card).filter(card => !card.hidden);
          visible.forEach(card => {
            const body = card.querySelector('[data-rd-rv-text]');
            const button = card.querySelector('[data-rd-rv-expand]');
            if (body && button && button.getAttribute('aria-expanded') !== 'true') button.hidden = body.scrollHeight <= body.clientHeight + 1;
          });
          grid.classList.toggle('is-single', visible.length === 1);
          const gap = parseFloat(getComputedStyle(grid).getPropertyValue('--rr-card-gap')) || 12;
          visible.map(card => [card, Math.ceil(card.getBoundingClientRect().height + gap)]).forEach(([card, span]) => {
            if (span > gap) card.style.gridRowEnd = `span ${span}`;
          });
        });
      };
      const filter = createReviewFilter(root, { anchor: '.rd-review-tools__filter', host: tools, products: [...new Set(entries.map(entry => entry.product).filter(Boolean))], onChange: apply });
      const sort = createReviewSort(root, { select: '.rd-review-tools__select', box: '.rd-review-tools__sort', host: tools });
      select.addEventListener('change', apply, { signal: lifetime.signal });
      return { disconnect() {
        lifetime.abort();
        cancelAnimationFrame(frame);
        filter.disconnect();
        sort.disconnect();
      } };
    }
    // Fill the initial view through Judge.me's own pagination, preserving grouping and filters.
    // While a filter is on, keep loading (up to 100 reviews) so it checks every review, not just the first pages.
    function createReviewPrefetch(root, syncSort) {
      const target = () => root.dataset.reviewFiltered === 'true' ? 100 : Number(root.dataset.initialReviews) || 10;
      const lifetime = new AbortController();
      const gated = new Map();
      let timer = 0;
      let startWatchdog = 0;
      let inFlight = false;
      let sawBusy = false;
      let beforeCount = 0;
      let previousCount = 0;
      let attempted = '';
      const items = () => [...root.querySelectorAll('.jdgm-review-list .jm-review-item[review-uuid]')];
      const busy = () => !!root.querySelector('.jm-loading-overlay--active') || !!root.querySelector('.jm-load-more-pagination button:disabled');
      const gate = active => {
        root.dataset.reviewAutoloading = String(active);
        if (active) {
          root.querySelectorAll('.jm-filters, .jm-filter-panel').forEach(control => {
            if (!gated.has(control)) gated.set(control, control.inert);
            control.inert = true;
          });
        } else {
          gated.forEach((inert, control) => { control.inert = inert; });
          gated.clear();
        }
        syncSort();
      };
      const refresh = () => {
        if (inFlight && busy()) sawBusy = true;
        clearTimeout(timer);
        timer = setTimeout(() => {
          if (!root.isConnected) return;
          const cards = items();
          const count = new Set(cards.map(card => card.getAttribute('review-uuid'))).size;
          if (busy()) return;
          if (inFlight) {
            if (!sawBusy && count === beforeCount) return;
            inFlight = false;
            clearTimeout(startWatchdog);
            gate(false);
          }
          if (count < previousCount) attempted = '';
          previousCount = count;
          if (!count || count >= target()) return;
          const button = root.querySelector('.jm-load-more-pagination button.jm-button');
          if (!button || button.disabled) return;
          const signature = `${root.querySelector('.jm-sort-filter__select')?.value}:${cards.map(card => card.getAttribute('review-uuid')).join(',')}`;
          if (signature === attempted) return;
          attempted = signature;
          beforeCount = count;
          inFlight = true;
          sawBusy = false;
          gate(true);
          button.click();
          clearTimeout(startWatchdog);
          startWatchdog = setTimeout(() => {
            if (inFlight && !busy() && items().length === beforeCount) {
              inFlight = false;
              gate(false);
            }
          }, 1800);
        }, 120);
      };
      const reset = () => { if (!inFlight) attempted = ''; refresh(); };
      root.addEventListener('change', reset, { signal: lifetime.signal });
      root.addEventListener('click', event => {
        if (event.target.closest('.jm-rating-filter, .jm-filter-panel__clear-btn')) reset();
      }, { signal: lifetime.signal });
      return { refresh, disconnect() {
        clearTimeout(timer);
        clearTimeout(startWatchdog);
        lifetime.abort();
        gate(false);
      } };
    }
    const english = document.documentElement.lang.toLowerCase().startsWith('en');
    const observers = new Map();
    const connect = () => {
      document.querySelectorAll('.rd-reviews--editorial').forEach(root => {
        if (observers.has(root)) return;
        // Bundle pages render their combined cards in rd-bundle-reviews; Judge.me only supplies the write-review form there.
        if (root.classList.contains('rd-reviews--combined')) {
          const tools = createBundleTools(root);
          if (tools) observers.set(root, tools);
          return;
        }
        const summary = root.querySelector('.rd-reviews__summary');
        let summarySignature = '';
        const refreshSummary = () => {
          const aggregate = root.querySelector('.jm-average-rating-display > .jm-cluster');
          const score = aggregate?.querySelector(':scope > .jm-text:first-child')?.textContent.trim() || '';
          const count = aggregate?.querySelector(':scope > .jm-text:nth-child(2)')?.textContent.trim() || '';
          const rating = Number(score.replace(',', '.'));
          const ready = Boolean(summary && count && /^\d+(?:[.,]\d+)?$/.test(score) && rating >= 0 && rating <= 5);
          if (root.dataset.summaryReady !== String(ready)) root.dataset.summaryReady = String(ready);
          if (summary && summary.hidden === ready) summary.hidden = !ready;
          if (!ready) { summarySignature = ''; return; }
          const signature = `${score}|${count}`;
          if (signature === summarySignature) return;
          summarySignature = signature;
          const scoreNode = summary.querySelector('.rd-reviews__score');
          const countNode = summary.querySelector('.rd-reviews__count');
          if (scoreNode.textContent !== score) scoreNode.textContent = score;
          if (countNode.textContent !== count) countNode.textContent = count;
          summary.style.setProperty('--rr-rating-fill', `${rating / 5 * 100}%`);
          summary.setAttribute('aria-label', `${root.dataset.ratingLabel.replace('__rating__', score)}, ${count}`);
        };
        const empty = root.querySelector('.rd-reviews__empty');
        const reviewFilter = createReviewFilter(root, { anchor: '.jm-custom-answer-filter', onChange: () => { syncFilter(); prefetch.refresh(); } });
        const reviewSort = createReviewSort(root, { allowed: ['created_at', 'highest_rating', 'lowest_rating', 'pictures_first'] });
        const prefetch = createReviewPrefetch(root, () => { reviewSort.refresh(); syncFilter(); });
        let sortInitialized = false;
        let frame = 0;
        const cards = new Set();
        const layout = () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const list = root.querySelector('.jdgm-review-list');
            if (!list || !list.getBoundingClientRect().width) return;
            const gap = parseFloat(getComputedStyle(list).getPropertyValue('--rr-card-gap')) || 12;
            const measurements = [...cards].map(card => [card, Math.ceil(card.getBoundingClientRect().height + gap)]);
            measurements.forEach(([card, span]) => {
              if (span > gap) card.style.gridRowEnd = `span ${span}`;
            });
            list.classList.add('rd-reviews__masonry');
          });
        };
        const resize = 'ResizeObserver' in window ? new ResizeObserver(layout) : null;
        // Filtering is client-side on Judge.me's cards; sorting stays with Judge.me so it covers every page.
        const syncFilter = () => {
          const active = reviewFilter.active();
          if (root.dataset.reviewFiltered !== String(active)) root.dataset.reviewFiltered = String(active);
          const items = root.querySelectorAll('.jdgm-review-list .jm-review-item');
          let shown = 0;
          items.forEach(card => {
            const match = reviewFilter.matches({ rating: ratingOf(card), photos: !!card.querySelector('.jm-media-thumbnail-list__thumbnail') });
            if (match) shown += 1;
            if (card.hasAttribute('data-rd-filtered') === match) card.toggleAttribute('data-rd-filtered', !match);
          });
          const text = active && items.length && !shown && root.dataset.reviewAutoloading !== 'true' ? root.dataset.filterEmpty : '';
          if (empty && empty.textContent !== text) empty.textContent = text;
          layout();
        };
        const enhance = () => {
          if (resize) {
            cards.forEach(card => {
              if (!root.contains(card)) {
                resize.unobserve(card);
                cards.delete(card);
              }
            });
            root.querySelectorAll('.jm-review-item').forEach(card => {
              if (!cards.has(card)) {
                cards.add(card);
                resize.observe(card);
              }
            });
            layout();
          }
          root.querySelectorAll('.jm-media-thumbnail-list__thumbnail img[srcset]').forEach(image => {
            const candidates = image.srcset.split(',').map(candidate => candidate.trim().split(/\s+/));
            const largest = candidates.filter(([, descriptor]) => /^\d+(\.\d+)?x$/.test(descriptor || '')).sort((a, b) => parseFloat(b[1]) - parseFloat(a[1]))[0];
            if (largest && candidates.length > 1) {
              image.srcset = `${largest[0]} 1x`;
              image.src = largest[0];
            }
          });
          const sort = root.querySelector('.jm-sort-filter__select');
          if (!sortInitialized && sort && root.querySelector('.jm-review-item')) {
            sortInitialized = true;
            if (root.dataset.photoReviewsFirst === 'true' && [...sort.options].some(option => option.value === 'pictures_first') && sort.value !== 'pictures_first') {
              sort.value = 'pictures_first';
              sort.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          if (english) {
            const label = root.querySelector('.jm-average-rating-display > .jm-cluster > .jm-text:nth-child(2)');
            const match = label?.textContent.trim().match(/^([\d,]+)\s+review$/i);
            if (match && Number(match[1].replaceAll(',', '')) !== 1) {
              label.textContent = `${match[1]} REVIEWS`;
            }
          }
          refreshSummary();
          reviewSort.refresh();
          reviewFilter.refresh();
          syncFilter();
          prefetch.refresh();
        };
        const observer = new MutationObserver(enhance);
        observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
        observers.set(root, { disconnect() {
          observer.disconnect();
          prefetch.disconnect();
          reviewSort.disconnect();
          reviewFilter.disconnect();
          resize?.disconnect();
          cancelAnimationFrame(frame);
          cards.clear();
        } });
        enhance();
      });
    };
    connect();
    document.addEventListener('shopify:section:load', connect);
    document.addEventListener('shopify:section:unload', event => {
      observers.forEach((observer, root) => {
        if (event.target.contains(root)) {
          observer.disconnect();
          observers.delete(root);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
